<section id="oao-accounts-and-services">
      <div class="bl-display--flex">
        <h3
          class="bl-font-weight--900 bl-font-color--base bl-font-size--22 bl-padding-top--8">
          {{'OaoAccountsServicesReview/includedAccounts'|dictionary}} </h3>
        <p class="bl-align-self--center bl-margin--0 bl-margin-top--24 bl-margin-top-sm--0 bl-flex--auto">
          <button type="button" (click)="redirectToEdit()" 
          class="bl-button bl-button-small bl-button-reverse bl-float--right">          
            <span class="bl-font-color--primary ">
              <span class="bl-font-size--14 cu-icons cu-edit bl-margin-right--4"></span>
              <span>{{ 'OaoAccountsServicesReview/edit' | dictionary }}</span>
            </span>
            <span class="bl-screen-reader-only">
              {{'OaoAccountsServicesReview/includedAccounts'|dictionary}}
            </span>
          </button>
        </p>
      </div>
      <div class="bl-border-bottom">
        <section class="bl-margin-bottom--16" *ngFor="let product of includedProducts">
          <div class="bl-display--flex bl-justify-content--center bl-align-items--flex-start bl-cursor--pointer">
            <div class="oao-bl-bg-silver  bl-padding--4 ">
              <img class="oao-icon-width" [src]="getIcons(product.type)" alt="optional-account-icon">
            </div>
            <div class="bl-width--100">
              <h3
                class="bl-font-weight--800 bl-flex--auto bl-font-size--18 bl-padding-top--4 bl-padding-left--16 bl-margin-bottom--8">
                {{product.name}}
              </h3>
              <div *ngIf="product.optionalServices" class="bl-font-color--slate">
                <div *ngFor="let opt of product.optionalServices" class=" bl-padding-left--16 bl-margin-bottom--8">
                  <div *ngIf="opt.isSelected"> {{'OaoAccountsServicesReview/added'|dictionary}} {{opt.name}} </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="bl-margin-bottom--16" *ngFor="let product of includedServices">
          <div class="bl-display--flex bl-justify-content--center bl-align-items--flex-start bl-cursor--pointer">
            <div class="oao-bl-bg-silver  bl-padding--4 ">
              <img class="oao-icon-width" [src]="getIcons(product.relatedProductTypeName)" alt="optional-account-icon">
            </div>
            <h3
              class="bl-font-weight--800 bl-flex--auto bl-font-size--18 bl-padding-top--8 bl-padding-left--8">
              {{product.relatedProductName}}
            </h3>
          </div>
        </section>
      </div>
    <section class="bl-border-bottom bl-padding-top--16" *ngIf="selectedProducts?.length||selectedMembershipServices?.length">
      
      <div class="bl-display--flex" >
        <h3
          class="bl-font-weight--900  bl-font-color--base bl-font-size--22 bl-padding-top--8">
          {{'OaoAccountsServicesReview/selectedAccounts'|dictionary}} </h3>
      </div>
      <div class="review-wrap-width">
        <section class="bl-margin-bottom--16" *ngFor="let product of selectedProducts">
          <div class="bl-display--flex bl-cursor--pointer">
            <div>
              <div class="bl-padding--4 oao-bl-bg-silver "><img class="oao-icon-width"
                  [src]="getIcons(product.type)" alt="optional-account-icon"></div>
            </div>
            <div class="w-100">
              <h3
                class="bl-font-weight--800 bl-flex--auto bl-font-size--18 bl-padding-top--8 bl-margin-bottom--8 bl-padding-left--16">
                {{product.name}}
              </h3>
              <div *ngIf="product.optionalServices" class="bl-font-color--slate ">
                <div *ngFor="let opt of product.optionalServices" class=" bl-padding-left--16 bl-margin-bottom--8">
                  <div *ngIf="opt.isSelected"> {{'OaoAccountsServicesReview/added'|dictionary}} {{opt.name}} </div>
                </div>
              </div>
              <div *ngIf="product.terms" class="bl-font-color--slate ">
                <div *ngFor="let term of product.terms">
                  <div *ngIf="term.isSelected">
                    <div class=" bl-padding-left--16 bl-margin-bottom--8 bl-font-weight--700 ">
                      {{'OaoAccountsServicesReview/added'|dictionary}} {{term.termInMonths}}
                      {{'OaoAccountsServicesReview/months'|dictionary}} </div>
                    <div *ngIf="term.shareNickName"
                      class="bl-display--flex bl-padding-left--16 bl-margin-bottom--8">
                      <div class="bl-col-6 bl-padding-x--0">{{'OaoAccountsServicesReview/shareNickName'|dictionary}}
                      </div>
                      <div class="bl-col-6 ">
                        {{term.shareNickName}}
                      </div>
                    </div>
                    <div *ngIf="term.termInMonths"
                      class="bl-display--flex bl-padding-left--16 bl-margin-bottom--8">
                      <div class="bl-col-6 bl-padding-x--0">{{'OaoAccountsServicesReview/term'|dictionary}} </div>
                      <div class="bl-col-6 ">
                        {{term.termInMonths}}
                      </div>
                    </div>
                    <div *ngIf="term.dividendOption"
                      class="bl-display--flex bl-padding-left--16 bl-margin-bottom--8">
                      <div class="bl-col-6 bl-padding-x--0">
                        {{'OaoAccountsServicesReview/dividendOption'|dictionary}}</div>
                      <div class="bl-col-6">
                        {{GetShareDividendName(term.dividendOption)}}
                      </div>
                    </div>
                    <div *ngIf="term.maturityOption"
                      class="bl-display--flex bl-padding-left--16 bl-margin-bottom--8">
                      <div class="bl-col-6 bl-padding-x--0">
                        {{'OaoAccountsServicesReview/maturityOption'|dictionary}}</div>
                      <div class="bl-col-6 ">
                        {{GetShareDisbursementName(term.maturityOption)}}
                      </div>
                    </div>
                    <div *ngIf="(!isShareCertificateAccount(product)) && term.taxYear"
                      class="bl-display--flex bl-padding-left--16 bl-margin-bottom--8">
                      <div class="bl-col-6 bl-padding-x--0">
                        {{'OaoAccountsServicesReview/taxYear'|dictionary}}</div>
                      <div class="bl-col-6 ">
                        {{term.taxYear}}
                      </div>
                    </div>
                    <div *ngIf = "!(isShareCertificateAccount(product))">
                      <div *ngIf="term.contributionSource"
                      class="bl-display--flex bl-padding-left--16 bl-margin-bottom--8">
                      <div class="bl-col-6 bl-padding-x--0">
                        {{'OaoAccountsServicesReview/contibutionSource'|dictionary}}</div>
                      <div class="bl-col-6 ">
                        {{GetShareContributionName(term.contributionSource)}}
                      </div>
                    </div>
                    </div>
                    <div *ngIf="term.contributionAmount"
                      class="bl-display--flex bl-padding-left--16 bl-margin-bottom--8">
                      <div class="bl-col-6 bl-padding-x--0" *ngIf = "!(isShareCertificateAccount(product))">
                        {{'OaoAccountsServicesReview/contributionAmount'|dictionary}}</div>
                        <div class="bl-col-6 bl-padding-x--0" *ngIf = "isShareCertificateAccount(product)">
                          {{'OaoAccountsServicesReview/openingAmount'|dictionary}}</div>
                      <div class="bl-col-6 ">
                        {{term.contributionAmount}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="product.taxYear" class="bl-font-color--slate ">
                <div class="bl-display--flex bl-padding-left--16 bl-margin-bottom--8">
                  <div class="bl-col-6 bl-padding-x--0">{{'OaoAccountsServicesReview/taxYear'|dictionary}}</div>
                  <div class="bl-col-6">
                    {{product.taxYear}}
                  </div>
                </div>
              </div>
              <div *ngIf = "!(isShareCertificateAccount(product))">
                <div *ngIf="product.contributionSource" class="bl-font-color--slate ">
                  <div class="bl-display--flex bl-padding-left--16 bl-margin-bottom--8">
                    <div class="bl-col-6 bl-padding-x--0">{{'OaoAccountsServicesReview/contibutionSource'|dictionary}}
                    </div>
                    <div class="bl-col-6">
                      {{GetShareContributionName(product.contributionSource)}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="bl-margin-bottom--16" *ngFor="let service of selectedMembershipServices">
          <div class="bl-display--flex bl-cursor--pointer">
            <div>
              <div class="bl-padding--4 oao-bl-bg-silver "><img class="oao-icon-width"
                  [src]="getIcons(service.relatedProductTypeName && service.relatedProductTypeName.toLowerCase())"
                  alt="optional-account-icon"></div>
            </div>
            <div class="w-100">
              <h3
                class="bl-font-weight--800 bl-flex--auto bl-font-size--18 bl-padding-top--4 bl-margin-bottom--8  bl-padding-left--16">
                {{service.relatedProductName}}
              </h3>
            </div>
          </div>
        </section>
      </div>
    </section>
    
    <section class="bl-display--flex bl-padding-top--16">
      <p> {{'OaoAccountsServicesReview/total'|dictionary}}
        <span class="bl-font-weight--800">{{totalProductsAndService}} {{'OaoAccountsServicesReview/items'|dictionary}}</span>
      </p>
</section>